
import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { QualificationFormProvider } from './hooks/useQualificationFormDialog';
import { initializeAnalyticsConsent } from './lib/analytics';

// Initialize analytics consent management
initializeAnalyticsConsent();

// Lazy load the main App component for better performance
const App = React.lazy(() => import('./App'));

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found. Failed to mount React application.');
}

const root = createRoot(container);
root.render(
  <QualificationFormProvider>
    <React.Suspense fallback={
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-t-kodi-primary border-b-kodi-primary rounded-full animate-spin" role="status" aria-label="Loading application"></div>
      </div>
    }>
      <App />
    </React.Suspense>
  </QualificationFormProvider>
);
